export enum STAT_TYPE {
  TEXT = 'text',
  NUMBER = 'number',
  PERCENT = 'percent',
  DOLLAR = 'dollar',
  IMAGE = 'image',
}
